
import React, { useState } from "react";
import { useTranslation } from "react-i18next";



import PageChange from "../pageChange";
import toast from "react-hot-toast";




const Search = (props) => {
    const [query, setQuery] = useState("");
    const [isDataLoad, setIsDataLoad] = useState(true)
    var { t } = useTranslation()





    async function getSearch(e) {
        e.preventDefault();

        // توکن ب سرور داده شده و اطلاعات کاربر دریافت
        await fetch(`${props.propsData}/${parseInt(query)}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            }
        }).then((res) => {
            res
                .json()
                .then((result) => {
                    if (result.data.length === 0) {
                        toast.error('دیتای وجود ندارد')
                        document.getElementById('search').value = "";
                    } else {
                        setIsDataLoad(true)
                        window.location.href = `/qrcode/${result.data[0]._id}`;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        });







    }


    // زدن اینتر
    function enterKeyPress(e) {
        if (e.key === "Enter") {
            getSearch(e);
        }
    }



    return (
        <>
            {isDataLoad ? (
                <>

                    <div className="" dir="ltr">
                        <label htmlFor="default-search" className="text-sm font-medium text-gray-900 sr-only dark:text-gray-300">{t("search")}</label>
                        <div className="relative">
                            <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                <svg aria-hidden="true" className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" tabIndex="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                            </div>
                            <input dir="rtl" type="search" id="search" value={query}
                                onChange={event => setQuery(event.target.value)} className="block w-full p-4 text-sm text-gray-900 border border-gray-300 rounded-lg pr-7 placeholder:pr-3 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("search_in")} required="" />
                            <button type="button"
                                onClick={getSearch}
                                onKeyPress={(e) => enterKeyPress(e)}
                                className="text-white absolute left-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">{t("search")}</button>
                        </div>
                    </div>


                </>
            ) : <PageChange />}
        </>
    )


}


export default Search;